import React from 'react';
import { getColorForSeniority } from './ColorUtils';
import CustomTooltip from './CustomTooltip';

const TalentInfoHeader = ({ 
  name, 
  roleCategory, 
  role, 
  yearsOfExperience, 
  seniority,
  showRationale = false
}) => {
  return (
    <div className="border border-blue-300 rounded-lg p-4 mb-6 bg-blue-50 print-break-inside-avoid">
      {showRationale ? (
        // Two-column layout with rationale displayed
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left column - Basic info (50%) */}
          <div>
            <div className="mb-2">
              <span className="font-bold">Name:</span> {name || 'N/A'}
            </div>
            {roleCategory && (
              <div className="mb-2">
                <span className="font-bold">Role Category:</span> {roleCategory}
              </div>
            )}
            <div className="mb-2">
              <span className="font-bold">Role:</span> {role || 'N/A'}
            </div>
            <div className="mb-2">
              <span className="font-bold">Years of Experience:</span> {yearsOfExperience || 'N/A'}
            </div>
          </div>
          
          {/* Right column - Seniority with rationale (50%) */}
          {seniority && (
            <div>
              <div className="mb-2">
                <span className="font-bold">Inferred Seniority:</span>
                <span 
                  className="ml-2 px-3 py-1 rounded-full text-white font-medium text-sm"
                  style={{ backgroundColor: getColorForSeniority(seniority.level) }}
                >
                  {seniority.level || "N/A"}
                </span>
              </div>
              {seniority.rationale && (
                <div className="mt-2">
                  <p className="text-sm text-gray-700 italic">{seniority.rationale}</p>
                  {seniority.context && seniority.context.length > 0 && (
                    <div className="mt-2">
                      <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
                        {seniority.context.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        // Original layout with tooltip
        <div className="flex flex-wrap items-center">
          <div className="mr-4 mb-2">
            <span className="font-bold">Name:</span> {name || 'N/A'}
          </div>
          {roleCategory && (
            <div className="mr-4 mb-2">
              <span className="font-bold">Role Category:</span> {roleCategory}
            </div>
          )}
          <div className="mr-4 mb-2">
            <span className="font-bold">Role:</span> {role || 'N/A'}
          </div>
          <div className="mr-4 mb-2">
            <span className="font-bold">Years of Experience:</span> {yearsOfExperience || 'N/A'}
          </div>
          {seniority && (
            <div className="flex items-center mb-2">
              <span className="font-bold mr-2">Inferred Seniority:</span>
              {seniority.rationale ? (
                <CustomTooltip content={
                  <div>
                    {seniority.rationale || "No rationale provided"}
                    {seniority.context && seniority.context.length > 0 && (
                      <div className="mt-2">
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          {seniority.context.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                }>
                  <span 
                    className="px-3 py-1 rounded-full text-white font-medium text-sm cursor-help"
                    style={{ backgroundColor: getColorForSeniority(seniority.level) }}
                  >
                    {seniority.level || "N/A"}
                  </span>
                </CustomTooltip>
              ) : (
                <span 
                  className="px-3 py-1 rounded-full text-white font-medium text-sm"
                  style={{ backgroundColor: getColorForSeniority(seniority.level) }}
                >
                  {seniority.level || "N/A"}
                </span>
              )}
            </div>
          )}
        </div>
      )}
      
      {/* Force rationale display in print view */}
      <div className="hidden print:block">
        {seniority && seniority.rationale && !showRationale && (
          <div className="mt-2">
            <div className="font-bold">Seniority Rationale:</div>
            <p className="text-sm text-gray-700">{seniority.rationale}</p>
            {seniority.context && seniority.context.length > 0 && (
              <div className="mt-2">
                <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
                  {seniority.context.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TalentInfoHeader;
